/*
 * Remembers the collection a shopper clicked a product from, so the product page can continue that
 * collection ("Continua a ver ..."). Only set on a click from a collection page; it lives in
 * sessionStorage, so it is gone when the tab is closed.
 */
(() => {
  const KEY = 'eva:from-collection';
  const match = location.pathname.match(/\/collections\/([^/]+)\/?$/);
  if (!match) return;

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.('a[href*="/products/"]');
      if (!link || !link.closest('#product-grid, .product-grid')) return;
      try {
        sessionStorage.setItem(KEY, match[1]);
      } catch (error) {
        // Storage can be blocked (private mode): the strip simply will not show.
      }
    },
    { capture: true, passive: true }
  );
})();
